import { PortalShadow } from "@redotech/redo-customer-portal-common/portal-customization";
import { resolveShadowValue } from "./shadow-presets";

export interface GlobalCardStyle {
  borderColor?: string | null;
  borderWidth?: number | null;
  borderRadius?: number | null;
  shadow?: PortalShadow | null;
}

const CARD_SELECTOR = (s: string) =>
  `${s}[data-ui="login-card"], ${s}[data-ui="card-content"]`;

// The two main portal cards from the builder's "Global cards" section: the
// login card and the primary display card (`card-content`) shown throughout
// the portal.
export function buildGlobalCardCssRules(
  s: string,
  globalCard: GlobalCardStyle | null | undefined,
): string[] {
  if (!globalCard) {
    return [];
  }

  const rules: string[] = [];

  const rawColor = globalCard.borderColor;
  const borderColor =
    typeof rawColor === "string" && rawColor.length > 0 ? rawColor : undefined;

  const borderWidth =
    typeof globalCard.borderWidth === "number"
      ? globalCard.borderWidth
      : undefined;

  if (borderColor !== undefined || borderWidth !== undefined) {
    const props: string[] = ["border-style: solid;"];
    // Default width is 0 — no border out of the box. A color alone stays
    // invisible until the merchant gives the card a width.
    props.push(`border-width: ${borderWidth ?? 0}px;`);
    if (borderColor !== undefined) {
      props.push(`border-color: ${borderColor};`);
    }
    rules.push(`${CARD_SELECTOR(s)} { ${props.join(" ")} }`);
  }

  if (typeof globalCard.borderRadius === "number") {
    rules.push(
      `${CARD_SELECTOR(s)} { border-radius: ${globalCard.borderRadius}px; }`,
    );
  }

  const shadowValue = resolveShadowValue(globalCard.shadow);
  if (shadowValue !== undefined) {
    rules.push(`${CARD_SELECTOR(s)} { box-shadow: ${shadowValue}; }`);
  }

  return rules;
}
